import React from 'react';
import { images } from '../data/images';
interface LogoProps {
  // White version for use over the hero image; original gray otherwise.
  light?: boolean;
}

// The transparent PNG has wide empty margins around the wordmark.
// This frame crops to the lettering so the visible logo is exactly the target width.
export function Logo({
  light = false
}: LogoProps) {
  return <span className="relative block aspect-[1790/285] w-[100px] overflow-hidden md:w-[120px] lg:w-[140px]" data-id="element-217" data-mp="msup636yvvcr">
      <img src={images.logo} alt="Alma Yoga" style={{
      filter: light ? 'brightness(0) invert(1)' : 'none'
    }} className="absolute left-[-4.5%] top-[-160%] h-auto w-[111.7%] max-w-none transition-[filter] duration-300 ease-in-out" data-id="element-218" data-mp="rrp772x41fvt" />
    </span>;
}